export default __webpack_public_path__ + "static/media/welcomeVideoFallback.bf0f2d00.mp4";